import React, { useState, useEffect } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { IoExpandOutline } from "react-icons/io5";
import { LiaCompressArrowsAltSolid } from "react-icons/lia";
import Layout from "../Layouts/layout";
import useAlertUtils from "../../../utils/common.utils";
import { useParams } from "react-router-dom";
import { fetchData } from "../../../services/apiService";

function PatientTestDetail() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { id } = useParams();
  const { alertError } = useAlertUtils();

  const [testDetail, setTestDetail] = useState(null);

  const getTestDetails = async (id) => {
    try {
      const data = await fetchData(`api/test/get-labTest-detail/${id}`);

      if (data.success === true) {
        setTestDetail(data.data);
      } else {
        alertError("Error Fetching User Data");
      }
    } catch (error) {
      alertError("Error Fetching User Data");
    }
  };

  useEffect(() => {
    getTestDetails(id);
  }, []);

  return (
    <div className="test-detail-page">
      <Layout>
        <div className="test-detail-wrapper">
          <div className="test-detail-header">
            <h1 className="test-detail-title">Patient Test Details</h1>
          </div>

          <div className="test-detail-body">
            <div className="test-detail-info">
              <div className="test-detail-row">
                <label>Test name</label>
                <div>{testDetail?.testName}</div>
              </div>
              <div className="test-detail-row">
                <label>Laboratory name</label>
                <div>{testDetail?.laboratoryName}</div>
              </div>
              <div className="test-detail-row">
                <label>Laboratory location</label>
                <div>{testDetail?.laboratoryLocation}</div>
              </div>
              <div className="test-detail-row">
                <label>Added Date</label>
                <div>
                  {new Date(testDetail?.createdAt).toLocaleDateString("en-US", {
                    weekday: "long",
                    month: "long",
                    day: "numeric",
                  })}
                </div>
              </div>
            </div>

            <div className="test-detail-preview">
              <div
                onClick={() => {
                  setIsModalOpen(true);
                }}
                className="expand-button"
              >
                <IoExpandOutline size={45} color="white" />
              </div>
              {testDetail?.testFileUrl && (
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <Viewer fileUrl={testDetail.testFileUrl} />
                </Worker>
              )}
            </div>
          </div>
        </div>
      </Layout>

      {isModalOpen && (
        <div
          className="pdf-modal-overlay"
          onClick={() => setIsModalOpen(false)}
        >
          <div className="pdf-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Full PDF</h2>
              <div
                className="close-button"
                onClick={() => setIsModalOpen(false)}
              >
                <LiaCompressArrowsAltSolid size={45} color="white" />
              </div>
            </div>
            <div className="modal-body">
              {testDetail?.testFileUrl && (
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <Viewer fileUrl={testDetail.testFileUrl} />
                </Worker>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PatientTestDetail;
